import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setPatientDoctorSelectorInDrawer } from "@/store/ui/ui";
import { toast } from "react-toastify";

import { RootState } from "@/store/store";
import { visitMessage } from "@/utils/constants";

function PatientBlock({
    toggleDrawer,
    isAppointmentComplete,
}: {
    toggleDrawer: (open: boolean) => void;
    isAppointmentComplete: boolean;
}) {
    const dispatch = useDispatch();
    const errors = useSelector((state: RootState) => state.ui.errors);
    const isEditAppointment = useSelector(
        (state: RootState) => state.ui.isEditAppointment,
    );

    const patientName = useSelector((state: RootState) =>
        isEditAppointment
            ? state.appointments?.existtAppointment?.patientId?.name
            : state.appointments?.newAppointment?.patientName,
    );

    const hasError = errors?.patientName && !patientName;

    return (
        <div
            className={`appointment_selector time-selector ${
                hasError ? "error_field" : ""
            }`}
            onClick={() => {
                if (!isAppointmentComplete) {
                    toggleDrawer(true);
                    dispatch(setPatientDoctorSelectorInDrawer("patient"));
                } else toast.error(visitMessage);
            }}
        >
            <p style={{ color: patientName ? "#090b0e" : "#47586E" }}>
                <span style={{ color: patientName ? "#090b0e" : "#47586E" }}>
                    {patientName === undefined || patientName === null
                        ? "Дані про пацієнта відсутні"
                        : patientName === ""
                        ? "Оберіть пацієнта (обов'язково)"
                        : patientName}
                </span>
            </p>
            <img
                src='/appointmenspage/arrow-down.svg'
                alt='logo_arrow'
                className='app_arrow_img'
            />
        </div>
    );
}
export default React.memo(PatientBlock);
